export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "mandatory-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["* Mandatory field"])}
      },
      "fr": {
        "mandatory-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["* Champ obligatoire"])}
      }
    }
  })
}
